/**
 * @fileoverview Componente responsável por padronizar o conteúdo de abas.
 */

import React from "react";

const TabPanel = ({ children, value, name, ...rest }) => {
	if (value === name) {
		return (
			<div
				role="tabpanel"
				id={`simple-tabpanel-${name}`}
				aria-labelledby={`simple-tab-${name}`}
				style={{ width: "100%", height: "100%", ...rest.style }}
				{...rest}
			>
				<>{children}</>
			</div>
		);
	} else return null;
};

export default TabPanel;
